angular.module('zc.zenclerkS')

  .component('zcsDashboardWidgetCampaignList', {
    templateUrl: '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-campaign-list.html',
    require: {
      dashboard: '^zcsDashboardMain'
    },
    controller: zcsDashboardWidgetCampaignListController
  });

zcsDashboardWidgetCampaignListController.$inject = ['$scope', '$q', 'Campaign'];
function zcsDashboardWidgetCampaignListController($scope, $q, Campaign) {
  const vm = this;

  vm.$onInit = () => {
    vm.project = vm.dashboard.project;
    vm.filters = Campaign.activeFilters();
  };

}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/dashboard/widgets/dashboard-widget-campaign-list.component.js